import { Popover } from '@mui/material';
import React, { FC, ReactNode } from 'react';

export type FlowSelectPopoverProps = {
  id: string;
  open: boolean;
  anchorEl: HTMLElement;
  onClose: () => void;
  children: ReactNode;
};

export const FlowSelectPopover: FC<FlowSelectPopoverProps> = ({
  id,
  open,
  anchorEl,
  onClose,
  children,
}) => {
  return (
    <Popover
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      slotProps={{
        paper: {
          sx: {
            maxHeight: '504px',
            height: '504px',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            padding: '0px',
            borderRadius: '8px',
          },
        },
      }}
      sx={{
        marginTop: '5px',
        '& .MuiPopover-paper': {
          padding: '0px',
        },
      }}
    >
      {children}
    </Popover>
  );
};
